import gCard from "@/components/g-card/g-card.vue"
import gButton from "@/components/g-button/g-button.vue"
import gForm from "@/components/g-form/g-form.vue";


const name = 'PDFOrcamentoFinal'
export default {
  name,
 
  components: {
    'g-card':gCard,
    'g-button': gButton,
    'g-form': gForm
   },

  props: {

    orcamentoId: {
        type: String,
        default: ''
      },
   },

  mounted () {

    if(this.orcamentoId){
        this.OrcamentoSelecionado = this.orcamentoId
      } else {
        this.OrcamentoSelecionado = this.$route.params.id
      }
      
    this.InformacoesClienteByOrcamentoId()

    this.options.push("0")
    this.options.push("1")
   },

   updated () {
    if(this.orcamentoId === ''){
      return
    }
    if(this.orcamentoId){
      this.OrcamentoSelecionado = this.orcamentoId
    } else {
      this.OrcamentoSelecionado = this.$route.params.id
    }
    
    this.InformacoesClienteByOrcamentoId()


    this.options.push("0")
    this.options.push("1")

  },

  data () {
    return {
      MelhorAproveitamento: '',
      LarguraPalete: '',
      AlturaPalete: '',
      ComprimentoPalete: '',
      ObservacaoPalete: '',
      OrcamentoDescricaoSequencia:null,
      DesabilitaCheckBox: false,
      DescricaoLote: [],
      InformacaoClienteArray:[],
      InformacaoLoteFreteArray:[],
      InformacaoOrcamentoComponenteArray:[],
      InformacaoOrcamentoProdutoArray:[],
      InformacaoOrcamentoQuantidadeArray: [],
      InformacaoObservacao: [],
      InformacaoObservacoesGerais: [],
      options: [],
      OrcamentoCritica: [],
      OrcamentoEmbalagem: [],
      OrcamentoGerais: [],
      OrcamentoSelecionado: null,
      OrcaQuantidade: [],
      OrcaQuantidadeDiaCarregamento: [],
      RazaoSocialText:null,
      riscoFacaProt: [],
      orcamento:null,
      nomeRepre: '',
      Empresa: '',
      ICMS:null,
      IPI: null,
      PisCofins: null,
      quebraLinha: false,
     }
  },

  methods: {
    novo_orcamento(){
      this.$router.push('/produto-novo-inicio')
    },
    consultarorcamento(){
      this.$router.push('/consultar-orcamento')
    },


    InformacoesClienteByOrcamentoId(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Cliente/GetClienteByOrcamento/${this.OrcamentoSelecionado}`,
      })
      .then((response) => {
        onchange
        this.InformacaoClienteArray = response.data.data
        this.ICMS = this.InformacaoClienteArray.icms
        this.IPI = this.InformacaoClienteArray.ipi
        this.PisCofins = this.InformacaoClienteArray.pisCofins
        if (this.ICMS === true){
          this.ICMS = ("ICMS   ")
          } else{
          this.ICMS = ("")
          }
    
          if (this.IPI === true){
          this.IPI = ("IPI   ")
          } else{
          this.IPI = ("")
          }
    
          if (this.PisCofins === true){
          this.PisCofins = ("PisCofins")
          } else{
            this.PisCofins = ("")
          }
        this.InformacoesCaracteristicas()
      })
      .catch(() => {
      });
    },

      InformacoesProdutoByOrcamentoId() {
        this.axios({
          method: 'get',
          url: process.env.VUE_APP_WEB_API + `/Produto/GetProdutoByOrcamentoId/${this.OrcamentoSelecionado}`,
        })
        .then((response) => {
          onchange
          this.InformacaoProdutoArray = response.data.data
        })
        .catch(() => {
        });
      },      
    incentivos(){
      this.incentivos
      if (this.ICMS === true){
      this.ICMS = ("ICMS   ")
      } else{
      this.ICMS = ("")
      }

      if (this.IPI === true){
      this.IPI = ("IPI   ")
      } else{
      this.IPI = ("")
      }

      if (this.PisCofins === true){
      this.PisCofins = ("PisCofins")
      } else{
        this.PisCofins = ("")
      }
    },

    InformacoesLoteFreteByOrcamentoId(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `LoteFrete/GetLoteFreteFinalByOrcamentoId/${this.OrcamentoSelecionado}`,
      })
      .then((response) => {
        onchange
        this.InformacaoLoteFreteArray = response.data.data
        this.riscoFacaProt = response.data.data.RiscoFacaPrototipo;
        this.InformacaoLoteFreteArray = response.data.data  
        this.InformacoesOrcamentoComponenteByOrcamentoId()

      })
      .catch(() => {
      });
    },

    InformacoesOrcamentoComponenteByOrcamentoId(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `OrcamentoComponente/GetOrcamentoComponenteProdutoNovoByOrcamentoId/${this.OrcamentoSelecionado}`,
      })
      .then((response) => {
        onchange
        this.InformacaoOrcamentoComponenteArray = response.data.data
        this.DesabilitaCheckBox = true;
        this.InformacaoOrcamentoComponenteArray = response.data.data
        if(this.InformacaoOrcamentoComponenteArray.length < 1){
          this.quebraLinha = true
        }
        this.InformacoesOrcamentoProdutoByOrcamentoId()

      })
      .catch(() => {
      });
    },

    InformacoesOrcamentoProdutoByOrcamentoId(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `OrcamentoProduto/GetOrcamentoProdutoNovoByOrcamentoId/${this.OrcamentoSelecionado}`,
      })
      .then((response) => {
        onchange
        this.InformacaoOrcamentoProdutoArray = response.data.data
        this.InformacoesOrcamentoQuantidadeByOrcamentoId()

        
      })
      .catch(() => {
      });
    },

    InformacoesOrcamentoQuantidadeByOrcamentoId(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `OrcamentoQuantidade/GetOrcamentoQuantidadeByOrcamentoId/${this.OrcamentoSelecionado}`,
      })
      .then((response) => {
        onchange
        this.InformacaoOrcamentoQuantidadeArray = response.data.data
        this.OrcaQuantidade = response.data.data
        this.OrcaQuantidadeDiaCarregamento = response.data.data
        this.InformacoesByOrcamentoId()
      })
     .catch(() => {
      });
    },

    InformacoesByOrcamentoId(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Orcamento/GetOrcamentoById/Get/${this.OrcamentoSelecionado}`,
     })
     .then((response) => {
        onchange
        this.InformacaoOrcamentoArray = response.data.data
        this.nomeRepre = response.data.data.nomeRepresentante
        this.Empresa = response.data.data.nome
        this.InformacaoObservacoesGerais = response.data.data.observacoesGerais
        this.orcamento = response.data.data.codigoExterno
        this.Observacao() 
      })
     .catch(() => {
      });
    },

    InformacoesCaracteristicas(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Orcamento/GetCaracteristicasProdutoFinalByOrcamentoId/Get/${this.OrcamentoSelecionado}`,
      })
      .then((response) => {
        onchange
        this.OrcamentoAmostra = response.data.data.amostra
        this.OrcamentoAmostraEspTecnica = response.data.data.amostraEspecificacaoTecnica
        this.OrcamentoAmostraOutros = response.data.data.outros
        this.OrcamentoAmostraDescOutros = response.data.data.descricaoOutrosMateriais
        
        this.OrcamentoDescricaoSequencia = response.data.data.descricaoSequencia

        this.OrcamentoGeraisFsc = response.data.data.fsc
        this.OrcamentoGeraisLegislacao = response.data.data.legislacao

        this.OrcamentoEmbalagemFilme = response.data.data.embalagemEspecificaFilmeEncolhivel
        this.OrcamentoEmbalagemCaixaColetiva = response.data.data.embalagemEspecificaCaixaColetiva
        this.OrcamentoEmbalagemPalete = response.data.data.embalagemEspecificaPalete
        this.OrcamentoEmbalagemOutros = response.data.data.embalagemOutros
        this.OrcamentoEmbalagemDescOutros = response.data.data.descricaoOutrasEmbalagens
        
        this.OrcamentoCritica1 = response.data.data.critica1
        this.OrcamentoCritica2 = response.data.data.critica2
        this.OrcamentoCritica3 = response.data.data.critica3
        this.OrcamentoCritica4 = response.data.data.critica4
        this.OrcamentoCritica5 = response.data.data.critica5

        let alturaPalete = response.data.data.alturaPalete;
        let larguraPalete = response.data.data.larguraPalete;
        let comprimentoPalte = response.data.data.comprimentoPalete;

        this.MelhorAproveitamento = response.data.data.melhorAproveitamento
        this.AlturaPalete =  alturaPalete ? alturaPalete + ' cm' : '--',
        this.LarguraPalete = larguraPalete ? larguraPalete + ' cm' : '--'
        this.ComprimentoPalete = comprimentoPalte ? comprimentoPalte + ' cm' : '--'
        this.ObservacaoPalete = response.data.data.observacaoPalete

        this.DescricaoLote = response.data.data.lote


        this.InformacoesLoteFreteByOrcamentoId()

      })
      .catch(() => {
      });
    },

    Observacao(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `OrcamentoQuantidade/GetObservacaoByOrcamentoId/${this.OrcamentoSelecionado}`,
      })
      .then((response) => {
        onchange
        this.InformacaoObservacao = response.data.data.observacao
        this.executaTermino()
      })
      .catch(() => {
      });
    },

    gerarPdf(){
      this.generatePdf()
    },

    generatePdf() {
      this.executarvisualizacao++
    },
    
    pdfFinal(){
        this.renderiza = true
        this.executarvisualizacao++
        this.OrcamentoSelecionado = this.$route.params.id
    },
    executaTermino(){ 
        this.$emit('termino')
      },

  },

  computed: { },
};